module.exports = __webpack_public_path__ + "img/app.b367508.png";


//////////////////
// WEBPACK FOOTER
// ./static/app.png
// module id = PRH0
// module chunks = 1 3